// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-callout {
  background-color: transparent;
  pointer-events: auto;
}

/* NOTE: Create a element that overlaps the container by 5000px on all sides.
 * This allows callouts to layout naturally and not be influenced by edges of
 * the window.
 */
.bolt-portal.bolt-layout-relative {
  bottom: -5000px;
  left: -5000px;
  right: -5000px;
  top: -5000px;
}

.bolt-light-dismiss {
  pointer-events: auto;
}

.bolt-callout-modal {
  background-color: rgba(0, 0, 0, 0.20);
  background-color: var(--palette-black-alpha-20,rgba(0, 0, 0, 0.20));
}
@media (forced-colors: active) {
  .bolt-callout-modal {
    background: transparent;
  }
}

.bolt-callout-content {
  background-color: rgba(255, 255, 255, 1);
  background-color: var(--callout-background-color,rgba(255, 255, 255, 1));
  z-index: 1;
}

.bolt-callout-shadow {
  box-shadow: 0px 6px 12px rgba(0, 0, 0, .132);
  box-shadow: 0px 6px 12px var(--callout-shadow-color,rgba(0, 0, 0, .132));
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-callout-shadow {
  box-shadow: none;
  border: 2px solid rgba(0, 120, 212, 1);
  border: 2px solid var(--focus-border-color,rgba(0, 120, 212, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-callout-shadow {
  box-shadow: none;
  border: 2px solid rgba(0, 120, 212, 1);
  border: 2px solid var(--focus-border-color,rgba(0, 120, 212, 1));
}

.bolt-callout-extra-large {
  width: 800px;
}
@media screen and (max-width: 1023px) {
  .bolt-callout-extra-large {
    max-width: 800px;
    min-width: 80%;
    width: auto;
  }
}

.bolt-callout-large {
  width: 640px;
}
@media screen and (max-width: 1023px) {
  .bolt-callout-large {
    max-width: 640px;
    min-width: 80%;
    width: auto;
  }
}

.bolt-callout-medium {
  width: 480px;
}

.bolt-callout-small {
  width: 320px;
}

.bolt-callout-auto {
  width: auto;
}

/*# sourceMappingURL=Callout.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/Callout/Callout.scss","webpack://./../azure-devops-ui/bin/Components/Callout/Callout.css","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/src/_coreStyles.scss"],"names":[],"mappings":"AAMA;EACI,6BAAA;EACA,oBAAA;ACLJ;;ADQA;;;EAAA;AAIA;EACI,eAAA;EACA,aAAA;EACA,cAAA;EACA,YAAA;ACLJ;;ADQA;EACI,oBAAA;ACLJ;;ADQA;EACI,qCE0Fe;ED/FjB,mEAAmE;AEyBjE;AFvBJ;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EDMI,wCAAA;ECJF,wEAAwE;EACxE,UAAU;ADMZ;;ACHA;ECsWQ,4CAAA;EF/VA,wEAAA;ACJR;AACA;ECqWQ,gBAAA;EFlWA,sCAAA;EACA,gEAAA;ACAR;AACA;EDGA,gBAAA;EACI,sCA7CwB;EC4C1B,gEAAgE;AC0T9D;;ADvTJ;EACE,YDCM;ACAR;AACA;EACE;IACE,gBAAgB;IDEpB,cAAA;IACI,WAxDkB;ECwDpB;AC+SE;;AD5SJ;EACE,YDAM;ACCR;AACA;EACE;IACE,gBAAgB;IDCpB,cAAA;IACI,WAnEmB;ECoErB;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA,sCAAsC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
